// ** Redux Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
// ** Axios Imports
import axios from 'axios'

export const setLoading = createAsyncThunk('appTaxTypes/setLoading', async (loadingState) => ({ ...loadingState }))

export const getData = createAsyncThunk('appTaxTypes/getData', async (params, { dispatch }) => {
  dispatch(setLoading({ getData: true }))
  const response = await axios.get('/TaxTypes/List', { params })

  dispatch(setLoading({ getData: false }))
  return {
    params,
    data: response.data
  }
})

export const appTaxTypes = createSlice({
  name: 'appTaxTypes',
  initialState: {
    data: [],
    totalRecords: 1,
    params: {},
    loadingState: { getData: false }
    // allData: []
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data.data.list.map(l => ({ ...l, recno: l.recNo }))
        state.totalRecords = action.payload.data.totalRecords
        state.params = action.payload.params
      })
      .addCase(setLoading.fulfilled, (state, action) => {
        state.loadingState = action.payload
      })
  }
})

export default appTaxTypes.reducer
